// @flow

import { useLocalizedInstantWeekDayName, formatInstant } from '@tectonics/utils/date';
import {
  usePendingIncomingPayment,
  getPaymentTypeCode,
  getNequiExpirationDatetime,
} from '@tectonics/prs/incoming-payment';
import nequi from '@tectonics/prs/nequi';

type VoucherExpiration = {|
  +formattedDateTime: string,
  +weekDay: string,
|};

export function useVoucherExpiration(): VoucherExpiration {
  const incomingPayment = usePendingIncomingPayment();
  const paymentTypeCode = getPaymentTypeCode(incomingPayment);
  const expirationDateTime = getNequiExpirationDatetime(incomingPayment);
  const weekDay = useLocalizedInstantWeekDayName({ date: expirationDateTime });

  if (paymentTypeCode !== 'nequi') {
    throw new Error(`Voucher Ticket Due Date Time - Not implemented yet for ${String(paymentTypeCode)}`);
  }

  return {
    formattedDateTime: formatInstant({
      date: expirationDateTime,
      formatString: nequi.dueDateFormat,
    }),
    weekDay,
  };
}
